import PropTypes from "prop-types";
export var currencyValueShape = PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.shape({
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currency: PropTypes.string
})]);